import { createContext, useContext, useEffect, useState } from "react";
import { api, setBaseCurrency } from "@/lib/api";

const AuthContext = createContext(null);

const loadBaseCurrency = () => {
  api
    .get("/settings")
    .then((res) => setBaseCurrency(res.data.base_currency))
    .catch(() => {
      /* mantiene la moneda por defecto */
    });
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      setChecked(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        loadBaseCurrency();
      })
      .catch(() => {
        localStorage.removeItem("token");
        setUser(false);
      })
      .finally(() => setChecked(true));
  }, []);

  const loginSuccess = (data) => {
    if (data.access_token) localStorage.setItem("token", data.access_token);
    setUser(data.user);
    loadBaseCurrency();
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore
    }
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checked, loginSuccess, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
